import { useContext, useEffect, useMemo, useState } from "react";
import { UserDto } from "../api/data-contracts";
import { UserRoleValues, UserWithRoleCheck } from "../common/types";
import UserContext from "../context/User.context";
import Storage from "../utils/Storage";
import { cacheCompanyFeatures } from "../utils/companyFeatures";

function useUser() {
  const storedUser = useMemo(() => JSON.parse(Storage.get("user")), []);

  const [user, setUser] = useState<UserDto | undefined>(storedUser);
  const { user: userContext, setUser: setUserContext } =
    useContext(UserContext);

  const logout = () => {
    setUser(undefined);
    Storage.remove("authToken");
    Storage.remove("refreshToken");
    Storage.remove("authTokenExpiresAt");
    Storage.remove("user");
  };

  useEffect(() => {
    if (user) {
      Storage.set("user", JSON.stringify(user));
      setUserContext(user);
      cacheCompanyFeatures((user.company as any)?.features);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  const userWithRoleFlags: UserWithRoleCheck | undefined = user
    ? {
        ...user,
        isUserRole: (userRole: UserRoleValues): boolean =>
          user?.role === userRole,
      }
    : undefined;

  return { user: userWithRoleFlags, userContext, setUser, logout };
}

export default useUser;
